/*
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-03-27 14:01:24
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-05-09 11:39:18
 * @FilePath: \intelligent-knowledge-qa-pc\src\components\globalComponents.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/* 全局组件注册 */

// 引入全局组件
import grid from './element/grid.vue';
import select from './element/select.vue';
import radio from './element/radio.vue';
import form from './element/form.vue';
import controller from './element/controller.vue';
import MainBodyLr from './layout/MainBodyLr.vue';
import PageHeadBack from './layout/PageHeadBack.vue';

import SearchWrap from './SearchWrap/index.vue';

import PopCertificate from './frame/widgets/PopCertificate.vue';
import FrameMain from './frame/widgets/FrameMain.vue';

// 注册全局组件
const GlobalComponents = { grid, select, radio, form, controller, MainBodyLr, PageHeadBack, PopCertificate, FrameMain };

// 常用的组件
const oftenUsed = { SearchWrap };

export default (app) => {
  for (let key in GlobalComponents) {
    app.component(GlobalComponents[key]['name'] || key, GlobalComponents[key]);
  }
  for (let key in oftenUsed) {
    app.component(oftenUsed[key]['name'] || key, oftenUsed[key]);
  }
};
